<h2 mat-dialog-title class="title">{{ title }}</h2>
<mat-dialog-content class="body">{{ body }}</mat-dialog-content>
<mat-dialog-actions>
  <button *ngIf="buttonTextNo" mat-button mat-dialog-close class="buttonTextNo">{{ buttonTextNo }}</button>
  <button *ngIf="buttonTextYes" mat-button [mat-dialog-close]="true" class="buttonTextYes">{{ buttonTextYes }}</button>
</mat-dialog-actions>